// const React = window.React = require('react');
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import MetaTags from 'react-meta-tags';

const HeadMetaTag = (props) => {

  const [t] = useTranslation('translation');

  const title = `Kura Text Audio Tools for Kura Storage by SpaceEight`;

  const description = `Kura Text Audio Tools by SpaceEight - ${t('headMeta01', 'Tools for handling text and audio data')}
Audio Transcriber ${t('headMeta02', 'is a tool to generate text transcript from audio sources such as audio file, video file, and recorded voices.')}

Voice Generator ${t('headMeta03', 'is a tool to generate audio from text input.')}

Answer Finder ${t('headMeta04', 'is a tool to find an answer in context text by asking question.')}
`;

  return (
    <Fragment>
      <MetaTags>
        <title>{title}</title>
        <meta name="description" content={description} />
        {/* <title>Page 1</title>
        <meta name="description" content="Some description." />
        <meta property="og:title" content="MyApp" />
        <meta property="og:image" content="path/to/image.jpg" /> */}
      </MetaTags>
    </Fragment>
  );
}

export default HeadMetaTag;